import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Table, Input } from 'antd';
import TableText from "../TableText";
import { toJS, runInAction, action } from 'mobx';

const { TextArea } = Input;

@inject('store')
@observer
class App extends Component {
    @action
    onChange = (name, value, i) => {
        let data = toJS(this.props.store.monthlyAnalysis.data);
        data[i][name] = value;
        this.props.store.monthlyAnalysis.data = data;
    }
    render() {
        const { data, notes, loading, deposit } = this.props.store.monthlyAnalysis;
        const width = document.body.offsetWidth > 2100 ? document.body.offsetWidth - 1800 : 300;
        const columns = type => [
            {
                title: '项目',
                dataIndex: 'name',
                key: 'name',
                fixed: 'left',
                width,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'text',
                        name: 'name',
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Jan"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };

                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'Jan',
                dataIndex: 'Jan',
                key: 'Jan',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Jan',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Jan"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };
                    return <TableText data={{
                        ...props
                    }} />
                }
            },
            {
                title: 'Feb',
                dataIndex: 'Feb',
                key: 'Feb',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Feb',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Feb"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'Mar',
                dataIndex: 'Mar',
                key: 'Mar',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Mar',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Mar"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'Apr',
                dataIndex: 'Apr',
                key: 'Apr',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Apr',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Apr"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };

                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'May',
                dataIndex: 'May',
                key: 'May',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'May',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["May"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };

                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'Jun',
                dataIndex: 'Jun',
                key: 'Jun',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Jun',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Jun"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };

                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'Jul',
                dataIndex: 'Jul',
                key: 'Jul',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Jul',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Jul"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };

                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'Aug',
                dataIndex: 'Aug',
                key: 'Aug',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Aug',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Aug"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };

                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'Sep',
                dataIndex: 'Sep',
                key: 'Sep',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Sep',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Sep"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };

                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'Oct',
                dataIndex: 'Oct',
                key: 'Oct',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Oct',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Oct"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };

                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'Nov',
                dataIndex: 'Nov',
                key: 'Nov',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Nov',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Nov"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };

                    return <TableText data={{ ...props }} />
                }
            },
            {
                title: 'Dec',
                dataIndex: 'Dec',
                key: 'Dec',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: 'Dec',
                        width: 150,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: type ? null : {
                            title: ["Dec"],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };

                    return <TableText data={{ ...props }} />
                }
            }
        ]
        return (
            <div className="">
                <Row className="secondary_title">一．现金流量分析</Row>
                <Table
                    columns={columns()}
                    dataSource={data.slice(0, 4)}
                    size="middle"
                    bordered
                    pagination={false}
                    className="content"
                    rowKey={(record, index) => index}
                    scroll={{ x: 2100 }}
                />
                <Table
                    columns={columns(true)}
                    dataSource={deposit}
                    size="middle"
                    bordered
                    pagination={false}
                    className="content"
                    rowKey={(record, index) => index}
                    scroll={{ x: 2100 }}
                />
                <Row className="note_title">酒店的现金流量趋势分析</Row>
                {
                    !loading &&
                    <TextArea
                        className="note m_b_80"
                        autosize={{ minRows: 8 }}
                        placeholder={`示例：\n当期的现金基本情况，比如现金收支是否包含业主往来款等非日常现金收支情况？未来现金是否充裕？是否有大额现金收支？`}
                        defaultValue={notes.cashFlow}
                        onBlur={e => {
                            runInAction(() => {
                                this.props.store.monthlyAnalysis.notes.cashFlow = e.target.value || "";
                            })
                        }}
                    />
                }

            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/table/monthlyAnalysis/cashFlow.js